import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { SkillsService } from "../../../auth/service/skills.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService, UserService } from "../../../auth/service";
import { UtilsService } from "../../../auth/service/utils.service";
import { Router } from "@angular/router";
import { TutorialService } from "../../../auth/service/tutorial.service";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-onboarding-skills-form",
  templateUrl: "./onboarding-skills-form.component.html",
  styleUrls: ["./onboarding-skills-form.component.scss"],
})
export class OnboardingSkillsFormComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public currentUser: ICurrentUser;
  public items_skills: any = [];
  public new_skill: string;
  public indexOfItemSkill: number = 0;
  public skillNotDeletable: Array<number> = [];
  public skills_list: Array<any> = [];

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {SkillsService} _skillService

   * @param _modalService
   * @param _utilService
   * @param _userService
   * @param _authenticationService
   * @param _router
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _skillService: SkillsService,
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    await this._skillService.getList();
    this.skills_list = this._skillService.list;
    this.currentUser = this._authenticationService.getCurrentUser();
    if (this.currentUser && this.currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    // recuperiamo altre skill che l'utente potrebbe già avere
    await this._userService
      .get(this.currentUser.hash)
      .then((result: any) => {
        // se ci sono delle skill già salvate le inserisco nell'array
        result.skills.map((skill) => {
          this.items_skills.push({
            skill: skill.skill_id,
            level: skill.level,
            primary: skill.primary,
            enabled: skill.enabled,
          });
        });
        // se c'è qualche esperienza creo un array di ID di skills prendendole dalle tecnologie inserite
        if (result.experiences.length > 0) {
          result.experiences.map((exp: any) => {
            if (exp.skill_ids) {
              exp.skill_ids.map((skill_id: number) => {
                skill_id = Number(skill_id);
                this.skillNotDeletable.push(Number(skill_id));
                const alreadyAdded: any = this.items_skills.find((skill: any) => Number(skill.skill) === skill_id);
                const isAnApprovedSkill: any = this._skillService.list_enabled.find((skill: any) => skill.id === Number(skill_id));
                if (!alreadyAdded) {
                  this.items_skills.push({
                    skill: skill_id,
                    level: "junior",
                    enabled: isAnApprovedSkill ? 1 : -1,
                  });
                }
              });
            }
          });
        }
      })
      .then(() => {
        this.items_skills = [
          ...this.items_skills.filter((skill: any) => skill.level === "senior"),
          ...this.items_skills.filter((skill: any) => skill.level === "middle"),
          ...this.items_skills.filter((skill: any) => skill.level === "junior"),
        ];
        this.addItem();
      });
    this._utilService.hideLoading();
  }

  onSetPrimarySkill(skill: any, i: number) {
    if (skill.primary) {
      this.items_skills.map((value: any, index: number) => {
        if (index !== i) {
          this.items_skills[index].primary = false;
        }
      });
    }
  }

  /*Funzione per controllare se una skill è gia stata inserita dall'utente*/
  async checkIfAlreadyInsertedSkill(value: any, index: number) {
    if (value === undefined) {
      return false;
    }
    let alreadyExists: any = this.items_skills.filter((item) => item.skill == value.id);
    if (alreadyExists && alreadyExists.length > 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      this.items_skills.splice(index, index + 1);
      return false;
    }
  }

  addItem() {
    this.items_skills.push({
      skill: "",
      level: "",
      primary: false,
    });
  }

  /**
   * DeleteItem
   *
   * @param index
   */
  deleteItem(index: number) {
    delete this.items_skills[index];
    this.items_skills = this.items_skills.filter((i) => i);
  }

  public modalOpen(modalBasic, index: number) {
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.indexOfItemSkill = index;
  }

  async addModalObject() {
    if (this.new_skill == null) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }

    const skillAlreadyExists = this.skills_list.find((skill) => skill.name === this.new_skill.trim());
    if (skillAlreadyExists) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      this.new_skill = "";
      return false;
    }
    this.items_skills.push({
      skill: this.new_skill,
      level: "junior",
      isNew: 1,
    });
    let alreadyExists: any = this.items_skills.filter((item) => item.skill == this.new_skill);
    if (alreadyExists && alreadyExists.length > 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      this.items_skills.splice(this.indexOfItemSkill, this.indexOfItemSkill + 1);
      this.new_skill = "";
      return false;
    }
    this.new_skill = "";
    // refreshiamo il valore di items_skills con l'output della funzione per avere le skills filtrate
    this.items_skills = this.filterSkillList();
  }

  /**
   * Filtro per avere solo le skills fillate
   */
  filterSkillList() {
    return (this.items_skills = this.items_skills.filter((i: any) => ((i.skill && i?.skill.length > 0) || i?.skill > 0) && i?.level.length > 0));
  }

  async save() {
    if (
      this.items_skills.length === 1 &&
      JSON.stringify(this.items_skills[0]) ===
        JSON.stringify({
          skill: "",
          level: "",
        })
    ) {
      await this._utilService.showSWALError({ text: "ERROR_SKILLS_LIST_EMPTY" });
      return false;
    }
    const checkSkillPrimary = this.items_skills.filter((skill: any) => skill.primary);
    if (checkSkillPrimary.length < 1) {
      return this._utilService.showSWALError({ text: "SELECT_PRIMARY_SKILL" });
    }
    this.items_skills.map((skill: any) => {
      skill.primary = skill.primary ? 1 : 0;
    });

    let hasError: boolean = false;

    this.items_skills.map((skill: any) => {
      if ((skill.skill === "" && skill.level !== "") || (skill.skill !== "" && skill.level === "")) {
        hasError = true;
      }
    });

    if (hasError) {
      await this._utilService.showSWALError({ text: "ERROR_SKILLS_FIELDS_EMPTY" });
      return false;
    }

    // removing empty skills
    this.items_skills = this.filterSkillList();

    //check duplicate skills
    const checkedArray = this.items_skills.reduce((unique, o) => {
      if (!unique.some((obj) => obj.skill === o.skill)) {
        unique.push(o);
      }
      return unique;
    }, []);

    if (this.items_skills.length !== checkedArray.length) {
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_SKILL" });
      return false;
    }
    //END check duplicate skills

    return this._userService
      .update(this.currentUser.hash, { skills: this.items_skills })
      .then(() => this._router.navigateByUrl("/onboarding/languages"))
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" }));
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
